export default {
  stuInfo: [
    {
      t: '学号',
      k: 'schoolNo',
      s: '0',
      o: '1',
      b: 'st'
    },
    {
      t: '姓名',
      k: 'authorName',
      s: '0',
      o: '1',
      b: 'st'
    },
    {
      t: '所在院系',
      k: 'academyName',
      s: '0',
      o: '1',
      b: 'st'
    },
    {
      t: '攻读学位类别',
      k: 'degreeName',
      s: '0',
      o: '1',
      b: 'st'
    },
    {
      t: '导师姓名',
      k: 'teacherName',
      s: '0',
      o: '1',
      b: 'st'
    },
    {
      t: '专业',
      k: 'pSecondSubjectName',
      s: '0',
      o: '1',
      b: 'st'
    }
  ],
  expertInfo: [
    {
      t: '专家学校名称',
      k: 'orgName',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家一级学科码',
      k: 'mFirstSubjectCode',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家一级学科名称',
      k: 'mFirstSubjectName',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家二级学科码',
      k: 'mSecondSubjectCode',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家二级学科名称',
      k: 'mSecondSubjectName',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家次要一级学科码',
      k: 'eFirstSubjectCode',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家次要一级学科名称',
      k: 'eFirstSubjectName',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家次要二级学科码',
      k: 'eSecondSubjectCode',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家次要二级学科名称',
      k: 'eSecondSubjectName',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家专业学位门类码',
      k: 'degreeCategoryCode',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家专业学位门类名称',
      k: 'degreeCategoryName',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家专业学位领域码',
      k: 'degreeDomainCode',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家专业学位领域名称',
      k: 'degreeDomainName',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家研究方向1',
      k: 'researchAreaOne',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家研究方向2',
      k: 'researchAreaTwo',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家研究方向3',
      k: 'researchAreaThree',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专家研究方向4',
      k: 'researchAreaFour',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '导师类别码',
      k: 'tutorType',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '导师类别',
      k: 'tutorType',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '最高学位码',
      k: 'expDegreeCode',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '最高学位',
      k: 'expDegree',
      s: '0',
      o: '1',
      b: 'ex'
    },
    {
      t: '专业技术职务',
      k: 'techPosition',
      s: '0',
      o: '1',
      b: 'ex'
    }
  ],
  paperInfo: [
    {
      t: '送审日期',
      k: 'submitTime',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '评议时间',
      k: 'reviewTime',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '分项评价意见1',
      k: 'partScoreOne',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '分项评价意见2',
      k: 'partScoreTwo',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '分项评价意见3',
      k: 'partScoreThree',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '分项评价意见4',
      k: 'partScoreFour',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '分项评价意见5',
      k: 'partScoreFive',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '分项评价意见6',
      k: 'partScoreSix',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '分项评价意见7',
      k: 'partScoreSeven',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '评阅意见',
      k: 'reviewOpinion',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '不足之处及建议',
      k: 'deficiencies',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '创新点评价1',
      k: 'innovationOne',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '创新点评价2',
      k: 'innovationTwo',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '创新点评价3',
      k: 'innovationThree',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '创新点评价4',
      k: 'innovationFour',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '创新点评价5',
      k: 'innovationFive',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '总分',
      k: 'score',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '总体评价',
      k: 'evaluation',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '答辩意见',
      k: 'reviewResult',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '熟悉程度',
      k: 'familiarLevel',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '是否推荐优秀',
      k: 'excellentLevel',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '推荐理由',
      k: 'description',
      s: '0',
      o: '1',
      b: 'pa'
    },
    {
      t: '论文题目',
      k: 'titleCn',
      s: '0',
      o: '1',
      b: 'pa'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/assets/js/exportFieldConfig.js